import { useQuery } from '@tanstack/react-query';
import api from '../lib/api';
import type { RunGroup, RunGroupAttempt } from '../types/run-group';

/**
 * WI-14: read-only run-group hooks backing the operator console. These only GET
 * projected execution state; the console never mutates placement.
 */
export function useRunGroups() {
  return useQuery<RunGroup[]>({
    queryKey: ['run-groups'],
    queryFn: async () => {
      const res = await api.get('/api/run-groups');
      return res.data;
    },
    refetchInterval: 15000,
  });
}

export function useRunGroup(id: string | undefined) {
  return useQuery<RunGroup>({
    queryKey: ['run-groups', id],
    queryFn: async () => {
      const res = await api.get(`/api/run-groups/${id}`);
      return res.data;
    },
    enabled: !!id,
    refetchInterval: 10000,
  });
}

export function useRunGroupAttempts(id: string | undefined) {
  return useQuery<RunGroupAttempt[]>({
    queryKey: ['run-groups', id, 'attempts'],
    queryFn: async () => {
      const res = await api.get(`/api/run-groups/${id}/attempts`);
      return res.data;
    },
    enabled: !!id,
    refetchInterval: 10000,
  });
}
